import { render, staticRenderFns } from "./sign-in.vue?vue&type=template&id=629d10d8&"
import script from "./sign-in.vue?vue&type=script&lang=js&"
export * from "./sign-in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SignInForm: require('/opt/build/repo/components/forms/SignInForm.vue').default})
